var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.0989 18C39.4967 18 38.1978 19.3612 38.1978 21.0402C38.1978 21.4614 38.2796 21.8627 38.4274 22.2274L32.3503 28.5961C32.0022 28.4412 31.6194 28.3554 31.2174 28.3554C30.8153 28.3554 30.4325 28.4412 30.0844 28.5961L26.4542 24.7918C26.602 24.427 26.6838 24.0258 26.6838 23.6045C26.6838 21.9255 25.3849 20.5643 23.7827 20.5643C22.1805 20.5643 20.8816 21.9255 20.8816 23.6045C20.8816 24.0257 20.9634 24.4269 21.1113 24.7917L15.034 31.1603C14.686 31.0054 14.3031 30.9196 13.9011 30.9196C12.2989 30.9196 11 32.2807 11 33.9598C11 35.6388 12.2989 37 13.9011 37C15.5033 37 16.8022 35.6388 16.8022 33.9598C16.8022 33.5386 16.7204 33.1373 16.5726 32.7726L22.6498 26.404C22.9978 26.5589 23.3807 26.6446 23.7827 26.6446C24.1847 26.6446 24.5675 26.5589 24.9156 26.404L28.5459 30.2084C28.3981 30.5731 28.3163 30.9744 28.3163 31.3956C28.3163 33.0746 29.6152 34.4358 31.2174 34.4358C32.8196 34.4358 34.1184 33.0746 34.1184 31.3956C34.1184 30.9744 34.0366 30.5731 33.8888 30.2084L39.966 23.8397C40.314 23.9946 40.6969 24.0804 41.0989 24.0804C42.7011 24.0804 44 22.7192 44 21.0401C44 19.3611 42.7011 18 41.0989 18Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 52,
    height: 52,
    rx: 13.5,
    stroke: "white",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/Icon1.4db0142d.svg";
export { ForwardRef as ReactComponent };